import { GenericLazyString, gettext } from '@eventbrite/i18n';
import { getCanonicalSearchUrl } from '@eventbrite/redux-destination';
import { logEvent } from '@eventbrite/statsig';
import React from 'react';
import { connect } from 'react-redux';
import { DiscoverState } from '../../../../types';
import { HEAP_SEE_MORE_BTN_CLICK } from '../../constants/analytics';
import { WEEKEND_EVENTBRITE_CATEGORY } from '../../constants/category';
import { HOMEPAGE_SUB_INTERFACES } from '../../utils/analytics';
import './CategoryEventsViewMore.scss';

interface CategoryEventsViewMoreProps {
    title?: string | GenericLazyString;
    category: string;
    locationSlug?: string;
}

const getSearchUrl = (locationSlug?: string, category?: string) => {
    const searchString: any = {
        slug: locationSlug,
    };
    if (category !== WEEKEND_EVENTBRITE_CATEGORY) {
        searchString['tags'] = category;
    } else {
        searchString['dates'] = category;
    }
    const path = getCanonicalSearchUrl(searchString);

    const searchPath = path.includes('?') ? `${path}&page=1` : `${path}?page=1`;

    return searchPath;
};

const CategoryEventsViewMore: React.FunctionComponent<
    CategoryEventsViewMoreProps
> = (props) => {
    const domElement = React.useRef(null);
    const searchUrl = getSearchUrl(props?.locationSlug, props?.category);
    const handleClick = () => {
        //todo

        logEvent(HEAP_SEE_MORE_BTN_CLICK, null, {
            ['carrouselCategory']: HOMEPAGE_SUB_INTERFACES[props.category],
        });
    };
    return (
        <div ref={domElement} className="category-events-view-more">
            <a
                href={searchUrl}
                onClick={() => handleClick()}
                className="category-events-view-more__link eds-text-color--ui-blue--hover"
            >
                {props.children ? props.children : gettext('View more')}
            </a>
        </div>
    );
};

const _mapStateToProps = ({ location }: DiscoverState) => {
    return {
        locationSlug: location.slug,
    };
};

export default connect(_mapStateToProps)(CategoryEventsViewMore);
